import React from 'react';
import { injectIntl } from 'react-intl';
import parse from 'html-react-parser';

const SMSPreview = (props) => {
  const contentToParse = typeof props.content === 'string' ? props.content : '';

  return (
    <div className='template-email'>
      <div className='template-body bg-ix-white'>
        <div className='template-content flex'>{parse(contentToParse)}</div>
      </div>
    </div>
  );
};

export default injectIntl(SMSPreview);
